import { Injectable} from '@angular/core';
import { ModalComponent } from '../../common/modal/modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  component!: ModalComponent;
  constructor() {
  }
  bindComponent(component: ModalComponent){
    this.component = component;
  }
  getInstance(){
    return this.component;
  }
}
